import { render, staticRenderFns } from "./CardInteligenciaTerritorialPotencialAgropecuarioAreaPlantadaImovel.vue?vue&type=template&id=1f12d6f0&scoped=true&lang=pug"
import script from "./CardInteligenciaTerritorialPotencialAgropecuarioAreaPlantadaImovel.vue?vue&type=script&lang=js"
export * from "./CardInteligenciaTerritorialPotencialAgropecuarioAreaPlantadaImovel.vue?vue&type=script&lang=js"
import style0 from "./CardInteligenciaTerritorialPotencialAgropecuarioAreaPlantadaImovel.vue?vue&type=style&index=0&id=1f12d6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f12d6f0",
  null
  
)

export default component.exports